import client from '../client'

export async function makeOfferBySeller({ offerAmount, directOfferId }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/MakeOfferBySeller`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ offerAmount, directOfferId }),
  })
}
